import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import connect from '../../store/connect';
import { breakpoint, color } from '../../styles/helpers/variables';
import {
  setViewstate,
  fetchGlobalSearch,
  removeGlobalSearch,
  fetchQuickSearch,
  removeQuickSearch
} from '../../actions/actionCreators';

class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryLength: 0,
      lastTimestamp: 0
    };
    this.inputRef = React.createRef();
    this.onKeyPress = this.onKeyPress.bind(this);
    this.clearInput = this.clearInput.bind(this);
  }

  onKeyPress(event) {
    if (event.key === 'Enter') {
      if (this.props.location.pathname.includes('/sok')) {
        this.props.fetchGlobalSearch(event.target.value);
      } else {
        this.props.history.push(`/sok/${window.encodeURIComponent(event.target.value)}`);
      }
    }
  }

  clearInput() {
    this.inputRef.current.value = '';
    this.inputRef.current.focus();
    this.setState({ queryLength: 0 });
    this.props.setViewstate('globalSearchActive', false);
  }

  globalSearchInputHandler(event) {
    const searchTimeout = 125;
    const { timeStamp } = event;
    const { value } = event.target;
    const { length } = value;

    if (timeStamp - searchTimeout > this.state.lastTimestamp && value && length >= 2) {
      this.props.fetchQuickSearch(value);
    } else {
      setTimeout(() => {
        if (timeStamp === this.state.lastTimestamp && value) {
          this.props.fetchQuickSearch(value);
        }
      }, searchTimeout);
    }

    this.setState({
      queryLength: length,
      lastTimestamp: timeStamp
    });
    this.props.setViewstate('globalSearchActive', !!length);
  }

  render() {
    return (
      <SearchInputContainer>
        <SearchInputInput
          innerRef={this.inputRef}
          onChange={event => {
            this.globalSearchInputHandler(event);
          }}
          onFocus={event => {
            if (this.state.queryLength > 0) {
              this.globalSearchInputHandler(event);
            }
          }}
          onKeyPress={this.onKeyPress}
          active={this.state.queryLength >= 1}
        />
        <SearchInputClear onClick={this.clearInput} active={this.state.queryLength >= 1} />
      </SearchInputContainer>
    );
  }
}

const SearchInputContainer = styled.div`
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    margin: -7.5px 0 0;
    left: 12.5px;
    height: 15px;
    width: 15px;
    background-image: url(/images/icons/search.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    pointer-events: none;
  }
`;

const SearchInputInput = styled.input.attrs({
  type: 'text',
  placeholder: 'Sök efter produkter, varumärke eller formgivare…'
})`
  display: block;
  width: 100%;
  padding: 8.5px 12.5px 8.5px 40px;
  border: none;
  border-radius: 0;
  outline: none;
  background-color: rgba(255, 255, 255, 0.25);
  color: ${color.white};
  font-size: 12px;
  font-style: italic;
  line-height: 1.5;
  ${props =>
    props.active &&
    css`
      padding: 8.5px 40px;
    `};
  @media screen and (min-width: ${breakpoint.large}px) {
    padding: 9.5px 12.5px 9.5px 40px;
    font-size: 14px;
    ${props =>
      props.active &&
      css`
        padding: 9.5px 40px;
      `};
  }
  &::placeholder {
    color: ${color.white};
  }
`;

const SearchInputClear = styled.button`
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  height: 35px;
  width: 27.5px;
  padding: 0;
  border: none;
  outline: none;
  background-color: transparent;
  color: ${color.white};
  cursor: pointer;
  @media screen and (min-width: ${breakpoint.large}px) {
    height: 40px;
  }
  ${props =>
    props.active &&
    css`
      display: block;
    `};
  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    height: 1px;
    width: 15px;
    background-color: ${color.white};
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;

SearchInput.defaultProps = {};

SearchInput.propTypes = {
  setViewstate: PropTypes.func.isRequired,
  fetchQuickSearch: PropTypes.func.isRequired,
  fetchGlobalSearch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default connect(SearchInput, {
  setViewstate,
  fetchGlobalSearch,
  removeGlobalSearch,
  fetchQuickSearch,
  removeQuickSearch
});



// WEBPACK FOOTER //
// ./src/components/Header/SearchInput.js